export default __webpack_public_path__ + "static/media/galactic-punks.cbd756b9.png";